module.exports = __webpack_public_path__ + "img/web.00dc149b.svg";